import { Shelf } from '@/Interfaces/common';
import { $ } from '@/Engine/stateInstance';
import { checkShelfDocking } from '@/Engine/eventHandlers/lib/checkShelfDocking';
import { detachShelfDistance } from '@/Constants/common';
import { detachShelf } from '@/Engine/eventHandlers/lib/attachShelf';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { attachRack } from '@/Engine/eventHandlers/lib/attachRack';
import { Line3 } from 'three';
import { markCollisions } from '@/Engine/eventHandlers/lib/markCollisions';

export function onShelfMoving(line: Line3, localLine: Line3) {
    const shelf = $.selectionBox.target as Shelf;
    const deltaX = Math.abs(localLine.start.x - localLine.end.x);
    if (deltaX > 0.01)
        $.bigDistanceFlag = true;

    // Двигаем полку
    let success;
    // if ($.bigDistanceFlag)
        success = $.selectionBox.setPositionDelta(line);
    // else {
    //     console.log('!!!');
    //     shelf.changePlace(line.end, shelf.getModulePosition(line.end));
    // }
    if (!success) return false;

    if (checkShelfDocking(shelf, localLine)) {
        $.selectionBox.update();
        markCollisions();
        // $.bigDistanceFlag = false;
        return true;
    }
    // Если в модуле больше одной полки и пытаемся перенести полку на detachModuleDistance
    // то создаем новый модуль
    if (shelf.rackModule && shelf.rackModule.shelves.length > 1) {
        if (Math.abs(localLine.start.x - localLine.end.x) > detachShelfDistance) {
            detachShelf(shelf);
        }
        markCollisions();
        return true;
    }

    // Если над полкой модуль
    if ($.selectionBox.upIntersection?.object && $.selectionBox.upIntersection?.object.side === shelf.side) {
        if ($.selectionBox.upIntersection.object.type === 'rackModule') {
            const intersectionRack = $.selectionBox.upIntersection.object as RackModule;
            attachRack(intersectionRack, shelf, true);
        } else if ([ 'shelf', 'panel' ].includes($.selectionBox.upIntersection.object.type)) {
            const intersectionShelf = $.selectionBox.upIntersection.object as Shelf;
            const intersectionRack = intersectionShelf.rackModule;
            if (intersectionRack && intersectionRack.side === shelf.side)
                attachRack(intersectionRack, shelf, true);
        }
        // new Line3(this.target.rays.up.origin, this.upIntersection.point)
    }
    // Если справа от полки модуль
    if ($.selectionBox.rightIntersection?.object && $.selectionBox.rightIntersection.object.side === shelf.side) {
        const distance = $.selectionBox.rightIntersection.distance;
        if ($.selectionBox.rightIntersection.object.type === 'rackModule') {
            const intersectionRack = $.selectionBox.rightIntersection.object as RackModule;
            if (distance && distance < 0.1 && intersectionRack.side === shelf.side) {
                attachRack(intersectionRack, shelf, false);
            }
        } else if ([ 'shelf', 'panel' ].includes($.selectionBox.rightIntersection.object.type)) {
            const intersectionShelf = $.selectionBox.rightIntersection.object as Shelf;
            const intersectionRack = intersectionShelf.rackModule;
            if (intersectionRack && distance && distance < 0.1 && intersectionRack.side === shelf.side)
                attachRack(intersectionRack, shelf, true);
        }
    }
    // Если слева от полки модуль
    if ($.selectionBox.leftIntersection?.object && $.selectionBox.leftIntersection.object.side === shelf.side) {
        const distance = $.selectionBox.leftIntersection.distance;
        if ($.selectionBox.leftIntersection.object.type === 'rackModule') {
            const intersectionRack = $.selectionBox.leftIntersection.object as RackModule;
            if (distance && distance < 0.1 && intersectionRack.side === shelf.side) {
                attachRack(intersectionRack, shelf, false);
            }
        } else if ([ 'shelf', 'panel' ].includes($.selectionBox.leftIntersection.object.type)) {
            const intersectionShelf = $.selectionBox.leftIntersection.object as Shelf;
            const intersectionRack = intersectionShelf.rackModule;
            if (intersectionRack && distance && distance < 0.1 && intersectionRack.side === shelf.side)
                attachRack(intersectionRack, shelf, true);
        }
    }
    markCollisions();
    return success;
}
